import React, { useState, useEffect } from 'react';
import Loading from 'app/components/common/Loading.jsx';
import FeedSearchResult from 'app/components/CreateFeed/FeedSearchResult.jsx';
import {
    fetchSuggestedFeedCategories,
    fetchSuggestedFeeds
} from 'app/modules/SuggestedFeedData.js';

const SuggestedFeeds = (props) => {
    const [ categories, setCategories ] = useState([]);
    const [ feeds, setFeeds ] = useState([]);
    const [ selectedCategory, setSelectedCategory ] = useState(1);
    const [ displayFeeds, setDisplayFeeds ] = useState([]);

    useEffect(() => {
        fetchSuggestedFeedCategories(props.app.config.appUrl)
            .then(setCategories)
            .catch(() => {
                // do something here
            });

        fetchSuggestedFeeds(props.app.config.appUrl)
            .then(setFeeds)
            .catch(() => {
                // do something here
            });

    }, []);

    useEffect(() => {
        // get feeds for default category once everything is loaded
        if (feeds.length !== 0 && displayFeeds.length === 0) {
            let nextDisplayFeeds = [];
            feeds.map((feed) => {
                if (feed.dsfc_id === selectedCategory) {
                    nextDisplayFeeds.push(feed);
                }
            });

            setDisplayFeeds(nextDisplayFeeds);
        }
    }, [feeds]);

    const categoryClick = (e) => {
        let categoryId = parseInt(e.currentTarget.dataset.id),
            nextDisplayFeeds = [],
            category = categories.find((category) => { return category.dsfc_id === categoryId; });

        setSelectedCategory(categoryId);


        if (props.recordEvent) {
            props.recordEvent({
                pub_id: props.user.detail.id,
                event_name: 'Suggested Feed Category Click',
                event_data: {
                    category: category.category
                }
            });
        }

        feeds.map((feed) => {
            if (feed.dsfc_id === categoryId) {
                nextDisplayFeeds.push(feed);
            }
        });

        setDisplayFeeds(nextDisplayFeeds);

    }

    if (categories.length === 0 || feeds.length === 0) {
        return (
            <Loading {...props}/>
        );
    }

    let imgPath = props.app.config.assetsUrl + "/" + props.app.config.imageUrl;

    return (
        <div className="suggested-feeds">
            <div className="suggested-feed-categories">
                {selectedCategory === 0 ? (
                    categories.map((category) => {
                        const iconMap = {
                            1: 'suggested-feeds/lightbulb.svg', // tech
                            2: 'suggested-feeds/briefcase.svg', // business
                            3: 'suggested-feeds/newspaper.svg', // news
                            4: 'suggested-feeds/star.svg', // entertainment
                            5: 'suggested-feeds/home.svg', // real estate
                            6: 'suggested-feeds/globe.svg' // culture
                        };
                        return (
                            <div key={`maximal-${category.dsfc_id}`} className="maximal-category" role="button" onClick={categoryClick} data-id={category.dsfc_id}>
                                <div className="category-icon"><img src={`${imgPath}/${iconMap[category.dsfc_id]}`}/></div>
                                <div className="category-name">{category.category}</div>
                            </div>
                        )
                    })
                ) : (
                    categories.map((category) => {
                        let className = 'minimal-category';

                        if (category.dsfc_id === selectedCategory) {
                            className += ' selected';
                        }

                        return (
                            <div key={`minimal-${category.dsfc_id}`} className={className} role="button" onClick={categoryClick} data-id={category.dsfc_id}>
                                <div className="category-name">{category.category}</div>
                            </div>
                        );
                    })
                )}
            </div>
            <div className="feed-list">
                {displayFeeds.length ? (
                    <div className="search-results">
                        <ul className="search-results-list">
                            {displayFeeds.map((feed, i) => {
                                let feedData = {
                                    visualUrl: feed.feed_icon,
                                    description: feed.feed_description,
                                    title: feed.feed_title,
                                    url: feed.feed_url,
                                };
                                return (
                                    <FeedSearchResult
                                        key={i}
                                        result={feedData}
                                        selectFeed={props.selectFeed}/>
                                );
                            })}
                        </ul>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default SuggestedFeeds;
